import { tdysObj } from './valToLab'
import { CommonType, OptionString } from '@/interface'
import { TDYS } from '@/enum/enum'

// 时间格式化
type timeDealValType = Date | string | number | undefined | null
export function timeDeal(val: timeDealValType, type?: string, separator = '-'): string {
  let result = ''
  const dataType = toString.call(val)
  let time: Date
  switch (dataType) {
    case '[object Date]':
      time = val as Date
      break
    case '[object String]':
      if (isNaN(Number(val))) {
        time = new Date(val as string)
      } else {
        time = new Date(Number(val))
      }
      break
    case '[object Number]':
      time = new Date(Number(val))
      break
    default:
      time = new Date()
      break
  }
  const y = time.getFullYear()
  const M = (time.getMonth() + 1).toString().padStart(2, '0')
  const d = time.getDate().toString().padStart(2, '0')
  const h = time.getHours().toString().padStart(2, '0')
  const m = time.getMinutes().toString().padStart(2, '0')
  const s = time.getSeconds().toString().padStart(2, '0')
  switch (type) {
    case 'year':
      result = `${y}`
      break
    case 'month':
      result = `${y}${separator}${M}`
      break
    case 'day':
      result = `${y}${separator}${M}${separator}${d}`
      break
    case 'minutes':
      result = `${y}${separator}${M}${separator}${d} ${h}:${m}`
      break
    case 'datetime':
    default:
      result = `${y}${separator}${M}${separator}${d} ${h}:${m}:${s}`
      break
  }
  return result
}
export const stringDateShow = (time: string | null, type = 'day'): string => {
  return time ? timeDeal(new Date(time.replace(/-/g, '/')), type) : ''
}
export type DeepValType = object | number | boolean | string | null | undefined | unknown[] | RegExp | Date | unknown
export const deepCopy = <T extends DeepValType>(cur: T): T => {
  let newVal: DeepValType
  const curType = toString.call(cur)
  switch (curType) {
    case '[object Array]': // 数组
      newVal = []
      for (let i = 0; i < (cur as DeepValType[]).length; i += 1) {
        ;(newVal as DeepValType[]).push(deepCopy((cur as DeepValType[])[i]))
      }
      break
    case '[object Object]': // 对象
      newVal = {}
      for (const i in cur) {
        ;(newVal as CommonType)[i] = deepCopy((cur as CommonType)[i])
      }
      break
    case '[object RegExp]': // 正则
      newVal = new RegExp(cur as RegExp)
      break
    case '[object Date]': // 时间
      newVal = new Date(cur as Date)
      break
    default:
      newVal = cur
  }
  return newVal as T
}
/**
 * 数据非空验证
 * @desc 验证数据是否为 null undefined [] {} ''
 * @param data
 * @return {boolean}
 */
export function isEmpty(data: unknown): boolean {
  if (data === null) return true
  if (data === undefined) return true
  if (Object.prototype.toString.call(data) === '[object Array]') return (data as []).length === 0
  if (Object.prototype.toString.call(data) === '[object Object]') return Object.keys(data).length === 0
  if (typeof data === 'string') return data.trim() === ''
  return false
}

/** 获取file大小的名称 */
export function fileSize(value: unknown) {
  if (typeof value == 'string') {
    return value
  }
  if (value == null || value === '') {
    return '0 Bytes'
  }
  const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let index = 0
  const srcsize = parseFloat(value as string)
  index = Math.floor(Math.log(srcsize) / Math.log(1024))
  let size: number | string = srcsize / Math.pow(1024, index)
  //  保留的小数位数
  size = size.toFixed(2)
  return size + unitArr[index]
}
export function clearEvent(e: CommonType) {
  e.preventDefault()
  if (e.stopPropagation) {
    e.stopPropagation()
  } else {
    e.cancelBubble = true //IE的清除方式
  }
}
// 阿拉伯数字转换大写
export function numberParseChina(money: number | string) {
  //汉字的数字
  const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  //基本单位
  const cnIntRadice = ['', '拾', '佰', '仟']
  //对应整数部分扩展单位
  const cnIntUnits = ['', '万', '亿', '兆']
  //对应小数部分单位
  const cnDecUnits = ['角', '分', '毫', '厘']
  //整数金额时后面跟的字符
  const cnInteger = '整'
  //整型完以后的单位
  const cnIntLast = '圆'
  //最大处理的数字
  const maxNum = '999999999999999.9999'
  //金额整数部分
  let integerNum
  //金额小数部分
  let decimalNum
  //输出的中文金额字符串
  let chineseStr = ''
  //分离金额后用的数组，预定义
  let parts
  if (money == '') {
    return ''
  }
  money = parseFloat(`${money}`)
  if (money >= +maxNum) {
    //超出最大处理数字
    return ''
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger
    return chineseStr
  }
  //转换为字符串
  money = money.toString()
  if (money.indexOf('.') == -1) {
    integerNum = money
    decimalNum = ''
  } else {
    parts = money.split('.')
    integerNum = parts[0]
    decimalNum = parts[1].substring(0, 4)
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0
    const IntLen = integerNum.length
    for (let i = 0; i < IntLen; i++) {
      const n = integerNum.substr(i, 1)
      const p = IntLen - i - 1
      const q = p / 4
      const m = p % 4
      if (n == '0') {
        zeroCount++
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0]
        }
        //归零
        zeroCount = 0
        if (parseInt(n) === 1 && m === 1) {
          chineseStr += cnIntRadice[m]
        } else {
          chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
        }
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q]
      }
    }
    chineseStr += cnIntLast
  }
  //小数部分
  if (decimalNum != '') {
    const decLen = decimalNum.length
    for (let i = 0; i < decLen; i++) {
      const n = decimalNum.substring(i, i + 1)
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i]
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger
  } else if (decimalNum == '' || /^0*$/.test(decimalNum)) {
    chineseStr += cnInteger
  }
  return chineseStr
}
export const rateOptions: OptionString[] = [
  { value: '0.17', label: '17%' },
  { value: '0.16', label: '16%' },
  { value: '0.13', label: '13%' },
  { value: '0.11', label: '11%' },
  { value: '0.1', label: '10%' },
  { value: '0.09', label: '9%' },
  { value: '0.06', label: '6%' },
  { value: '0.05', label: '5%' },
  { value: '0.04', label: '4%' },
  { value: '0.03', label: '3%' },
  { value: '0.015', label: '1.5%' },
  { value: '0.01', label: '1%' },
  { value: '0.005', label: '0.5%' },
  { value: '0', label: '0%' }
]
// 单位
export const unitOptions: Array<{ value: string }> = [
  { value: '分' },
  { value: '角' },
  { value: '元' },
  { value: '千元' },
  { value: '万元' },
  { value: '亿元' },
  { value: '两' },
  { value: '斤' },
  { value: '毫克' },
  { value: '克' },
  { value: '千克(公斤)' },
  { value: '吨' },
  { value: '千吨' },
  { value: '万吨' },
  { value: '磅' },
  { value: '毫米' },
  { value: '厘米' },
  { value: '分米' },
  { value: '米' },
  { value: '千米（公里）' },
  { value: '万米' },
  { value: '码' },
  { value: '英尺' },
  { value: '平方毫米' },
  { value: '平方厘米' },
  { value: '平方分米' },
  { value: '平方米' },
  { value: '平方公里' },
  { value: '公顷' },
  { value: '亩' },
  { value: '毫升(立方厘米)' },
  { value: '公升(立方分米)' },
  { value: '立方米（方）' },
  { value: '千立方米' },
  { value: '万立方米' },
  { value: '亿立方米' },
  { value: '份' },
  { value: '组' },
  { value: '本' },
  { value: '箱' },
  { value: '卷' },
  { value: '瓦（W）' },
  { value: '千瓦' },
  { value: '万瓦' },
  { value: '千伏安时' },
  { value: '千瓦时（度）' },
  { value: '千千瓦时（千度）' },
  { value: '万千瓦时' },
  { value: '位（Bit）' },
  { value: '字节（B）' },
  { value: '千字节（KB）' },
  { value: '兆字节（MB）' },
  { value: '吉字节（GB）' },
  { value: '太字节（TB）' },
  { value: '皮字节（PB）' },
  { value: '个' },
  { value: '支' },
  { value: '只' },
  { value: '把' },
  { value: '条' },
  { value: '台' },
  { value: '架' },
  { value: '辆' },
  { value: '头' },
  { value: '件' },
  { value: '双' },
  { value: '套' },
  { value: '打' },
  { value: '包' },
  { value: '批' },
  { value: '匹' },
  { value: '部' },
  { value: '座' },
  { value: '艘' },
  { value: '张' },
  { value: '枝' },
  { value: '根' },
  { value: '块' },
  { value: '卷' },
  { value: '副' },
  { value: '片' },
  { value: '瓶' },
  { value: '标准箱' },
  { value: '万支' },
  { value: '盒' },
  { value: '桶' },
  { value: '枚' },
  { value: '次' },
  { value: '项' },
  { value: '株（棵）' },
  { value: '户' },
  { value: '点' },
  { value: '袋' },
  { value: '档' },
  { value: '朵' },
  { value: '顶' },
  { value: '罐' },
  { value: '回路' },
  { value: '间' },
  { value: '捆' },
  { value: '例' },
  { value: '令' },
  { value: '箩' },
  { value: '对' },
  { value: '门' },
  { value: '面' },
  { value: '付' },
  { value: '盘' },
  { value: '具' },
  { value: '圈' },
  { value: '扇' },
  { value: '束' },
  { value: '刷' },
  { value: '卡' },
  { value: '听' },
  { value: '筒' },
  { value: '粒' },
  { value: '串' },
  { value: '盏' },
  { value: '合' },
  { value: '轴' },
  { value: '尊' },
  { value: '节' },
  { value: '万双' },
  { value: '板' },
  { value: '版' },
  { value: '盆' },
  { value: '亿支' },
  { value: '台（套）' },
  { value: '万台' },
  { value: '万块' },
  { value: '万部' },
  { value: '床' },
  { value: '羽' },
  { value: '克拉' },
  { value: '盎司' },
  { value: '秒' },
  { value: '分钟' },
  { value: '小时' },
  { value: '日' },
  { value: '月' },
  { value: '季' },
  { value: '年' },
  { value: '分贝' }
]
// 特定业务Options
export const tdysOptions: OptionString[] = [
  { value: TDYS.FTDYS, label: tdysObj[TDYS.FTDYS] },
  // { value: TDYS.XT, label: tdysObj[TDYS.XT] },
  { value: TDYS.JZFW, label: tdysObj[TDYS.JZFW] },
  { value: TDYS.HWYSFW, label: tdysObj[TDYS.HWYSFW] },
  { value: TDYS.BDCXS, label: tdysObj[TDYS.BDCXS] },
  { value: TDYS.BDCZL, label: tdysObj[TDYS.BDCZL] },
  // { value: TDYS.TXF, label: tdysObj[TDYS.TXF] },
  // { value: TDYS.LKYSFW, label: tdysObj[TDYS.LKYSFW] },
  { value: TDYS.ZY, label: tdysObj[TDYS.ZY] },
  { value: TDYS.MZ, label: tdysObj[TDYS.MZ] },
  { value: TDYS.RCPXS, label: tdysObj[TDYS.RCPXS] },
  { value: TDYS.CPY, label: tdysObj[TDYS.CPY] },
  // { value: TDYS.TLJ, label: tdysObj[TDYS.TLJ] },
  { value: TDYS.JDC, label: tdysObj[TDYS.JDC] },
  // { value: TDYS.ESC, label: tdysObj[TDYS.ESC] },
  { value: TDYS.RCPSG, label: tdysObj[TDYS.RCPSG] }
  // { value: TDYS.GFSG, label: tdysObj[TDYS.GFSG] }
  // { value: TDYS.JY, label: tdysObj[TDYS.JY] }
]
// 去空格
export const trimSpace = (obj: CommonType | CommonType[]) => {
  const curType = toString.call(obj)
  if (curType === '[object Array]') {
    for (let i = 0; i < obj.length; i++) {
      const value = (obj as CommonType[])[i]
      const type = toString.call(value)
      if (type === '[object String]') {
        ;(obj as CommonType[])[i] = value.replace(/(^\s*)|(\s*$)/g, '')
      } else if (['[object Object]', '[object Array]'].includes(type)) {
        trimSpace(value)
      }
    }
  } else {
    for (const key in obj) {
      const value = (obj as CommonType)[key]
      const type = toString.call(value)
      if (type === '[object String]') {
        ;(obj as CommonType)[key] = value.replace(/(^\s*)|(\s*$)/g, '')
      } else if (['[object Object]', '[object Array]'].includes(type)) {
        trimSpace(value)
      }
    }
  }
  return obj
}
export const createRandomNumbers = () => {
  return Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2)
}
